import mypic from '../assets/mypic.jpg'
import {useTypewriter, Cursor} from 'react-simple-typewriter';
import Aashish from '../assets/Aashish.pdf';
import './Home.css';
import React from "react";
import { TagCloud } from 'react-tagcloud'

const data = [
  { value: 'JAVA', count: 35 },
  { value: 'JavaScript', count: 38 },
  { value: 'React JS', count: 33 },
  { value: 'HTML5', count: 33 },
  { value: 'CSS3', count: 20 },
  { value: 'UI Design', count: 22 },
  { value: 'Figma', count: 7 },
  { value: 'ECMAScript', count: 25 },
  { value: 'TypeScript', count: 15 },
  { value: 'NPM', count: 11 },
  { value: 'Bootstrap', count: 18 },
  { value: 'SQL', count: 21 },
  { value: 'GIT GITHUB', count: 22 },
]

const customRenderer = (tag, size, color) => (
  <span
    key={tag.value}
    style={{
      animation: 'blinker 3s linear infinite',
      animationDelay: `${Math.random() * 2}s`,
      fontSize: `${size / 2}em`,
      border: `2px solid ${color}`,
      margin: '3px',
      padding: '3px',
      display: 'inline-block',
      color: 'white',
    }}
  >
    {tag.value}
  </span>
)
export const Home = () =>{

    const [text] = useTypewriter({
        words:['Web Developer' , 'FrontEnd Developer' , 'UI Designer' , 'Java Developer'],
        loop:{},
        typeSpeed:100,
        delaySpeed:100,
    });

    return(
   <>
   <div className="container" id="home">
        <div className="homeleft">
            <h2>Hey, I Am <br/> </h2>
            <h1 className='grad'>Aashish Lal</h1>
            <h2>
            <span className='typewriter'>
                {text}
                </span>
                <Cursor/>
                </h2>
                <br/>
                <a className='btn btn-success' href={Aashish} download="Aashish Resume.pdf">Download Resume</a>
        </div>
        <div className="homeright">
           <img className='mypic' src={mypic} alt="My Pic"/>
        </div>
   </div>
   <div className='skills'>
    <div className='leftskill'>
    <h2>TECHNICAL SKILLS</h2>
    <ul>
        <li>JAVA</li>
        <li>Java Script</li>
        <li>React Js</li>
        <li>Figma</li>
        <li>UI Design</li>
        <li>HTML</li>
        <li>CSS</li>
        <li>Bootstrap</li>
        <li>SQL</li>
        <li>GIT, GIT-HUB</li>
        <li>MS-Office</li>
    </ul>
    </div>
    <div className="text-shpere">
    <TagCloud tags={data} minSize={1} maxSize={5} renderer={customRenderer} />
            </div>
   </div>
   </>
)};